import { useState, useEffect, useCallback } from 'react';
import api from '../api/client';

/**
 * Hook for fetching and managing single cluster data
 */
export function useCluster(clusterId) {
  const [data, setData] = useState(null);
  const [regional, setRegional] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchData = useCallback(async () => {
    if (!clusterId) return;

    setLoading(true);
    setError(null);

    try {
      const [clusterResponse, regionalResponse] = await Promise.all([
        api.cluster(clusterId),
        api.clusterRegional(clusterId),
      ]);

      setData(clusterResponse.data);
      setRegional(regionalResponse.data);
    } catch (err) {
      setError(err.message || 'Failed to load cluster');
    } finally {
      setLoading(false);
    }
  }, [clusterId]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const updateStatus = async (status, statusNote, updatedBy) => {
    try {
      const response = await api.updateClusterStatus(clusterId, {
        status,
        status_note: statusNote,
        updated_by: updatedBy,
      });

      // Update local state
      setData(prev => ({
        ...prev,
        status: response.data.status,
        status_note: response.data.status_note,
        status_updated_at: response.data.status_updated_at,
        status_updated_by: response.data.status_updated_by,
      }));

      return response.data;
    } catch (err) {
      throw err;
    }
  };

  const refresh = () => {
    fetchData();
  };

  return {
    data,
    regional,
    loading,
    error,
    updateStatus,
    refresh,
  };
}

export default useCluster;
